import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {TriggerService} from "../../../common/trigger/triggerService";
import {resolve} from "../../../container";
import {LocalStorage} from "../../../common/clientStorage";
import {Dialogs} from "./dialogs";
import type {PropertyValues} from "lit";

interface ClientStorageStatus {
    enabled?: boolean;
}

@customElement("eop-trigger-dialog")
export class EopTriggerDialog extends UnLitElement {

    @property({attribute: "dialog-id"})
    private dialogId: string;
    @property({attribute: "data-trigger"})
    private trigger: string;
    @property({attribute: "client-storage-key", type: String})
    public clientStorageKey: string;

    public constructor(
        private triggerService: TriggerService = resolve(TriggerService),
        private dialogs: Dialogs = resolve(Dialogs),
        private localStorage: LocalStorage = resolve(LocalStorage)
    ) {
        super();
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        this.bootStrap();
    }

    private bootStrap(): void {
        const openBootStrappedDialog = (): void => {
            if (!this.isEnabledAccordingToStorage()) {
                return;
            }
            this.dialogs.open(this.dialogId);
            this.disablePersistently();
        };
        this.triggerService.forEvent(this.trigger)
            .createTrigger(this, () => openBootStrappedDialog());
    }

    private isEnabledAccordingToStorage(): boolean {
        if (!this.clientStorageKey) {
            return true;
        }
        const storageContent = this.localStorage.fetch<ClientStorageStatus>(this.clientStorageKey);
        return storageContent?.enabled ?? true;
    }

    protected disablePersistently(): void {
        if (!this.clientStorageKey) {
            return;
        }
        const storageData: ClientStorageStatus = {enabled: false};
        this.localStorage.save(this.clientStorageKey, storageData);
    }
}